var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18616 2.40875C2.9633 4.675 6.24485 8.875 6.24485 8.875V14.125C6.24485 14.6063 6.64075 15 7.12463 15H8.88417C9.36805 15 9.76394 14.6063 9.76394 14.125V8.875C9.76394 8.875 13.0367 4.675 14.8138 2.40875C15.2625 1.83125 14.849 1 14.1188 1H1.88118C1.15097 1 0.737479 1.83125 1.18616 2.40875Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic-filter.d815af9f22bf8f004315fc9d00cd51af.svg";
export { ForwardRef as ReactComponent };